/**
 * @file Frontend module — pages/SubmittedDatasetDetails/SubmittedDatasetDetail.tsx.
 */

import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { contributorSubmittedDatasetDetailPath } from "../Dashboard/Contributor/contributorDashboardNavigation";

/** Legacy route — contributor detail now lives inside the dashboard. */
const SubmittedDatasetDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Navigate to="/dashboard?section=SubmittedDataset" replace />;
  }

  return <Navigate to={contributorSubmittedDatasetDetailPath(id)} replace />;
};

/** React component — Submitted Dataset Detail. */
export default SubmittedDatasetDetail;
